(() => {
  const s = document.currentScript;
  const FREQ = s?.dataset?.gpFrequency || 'once_per_day';
  const RESHOW_MIN = Number(s?.dataset?.gpReshow || 30);
  const DELAY_SEC = Number(s?.dataset?.gpDelay || 3);
  const NS = (s?.dataset?.gpNamespace || 'v1').trim();

  const LS_LAST = `gp_${NS}_last_shown`;
  const LS_CLOSED = `gp_${NS}_closed_at`;
  const SS_SHOWN = `gp_${NS}_session_shown`;
  const SS_CLOSED = `gp_${NS}_session_closed`;

  const $el = document.getElementById('global-popup');
  if (!$el) return;

  const now = () => Date.now();
  const minToMs = m => m * 60 * 1000;

  function canShow() {
    // If closed this session and reshow=0, don't show again
    if (RESHOW_MIN === 0 && sessionStorage.getItem(SS_CLOSED)) return false;

    // If closed and reshow > 0, check time
    const closedAt = Number(localStorage.getItem(LS_CLOSED) || 0);
    if (closedAt && RESHOW_MIN > 0 && now() < closedAt + minToMs(RESHOW_MIN)) return false;

    const lastShown = Number(localStorage.getItem(LS_LAST) || 0);

    switch (FREQ) {
      case 'always':
        return true;
      case 'every_visit':
        return !sessionStorage.getItem(SS_SHOWN);
      case 'once_per_day':
        return now() - lastShown > minToMs(1440);
      case 'once_per_week':
        return now() - lastShown > minToMs(10080);
      case 'once_per_month':
        return now() - lastShown > minToMs(43200);
      default:
        return true;
    }
  }

  function open() {
    $el.classList.add('is-open');
    $el.setAttribute('aria-hidden', 'false');
    localStorage.setItem(LS_LAST, String(now()));
    sessionStorage.setItem(SS_SHOWN, '1');
  }

  function close() {
    $el.classList.remove('is-open');
    $el.setAttribute('aria-hidden', 'true');
    localStorage.setItem(LS_CLOSED, String(now()));
    sessionStorage.setItem(SS_CLOSED, '1');
  }

  // Close button
  $el.querySelector('[data-gp-close]')?.addEventListener('click', close);

  // Click on overlay (outside modal) closes
  $el.addEventListener('click', e => {
    if (e.target === $el) close();
  });

  // Init
  document.addEventListener('DOMContentLoaded', () => {
    if (!canShow()) return;
    setTimeout(open, DELAY_SEC * 1000);
  });
})();
